import { render, staticRenderFns } from "./search-comp.vue?vue&type=template&id=55f19bd8&scoped=true&"
import script from "./search-comp.vue?vue&type=script&lang=js&"
export * from "./search-comp.vue?vue&type=script&lang=js&"
import style0 from "./search-comp.vue?vue&type=style&index=0&id=55f19bd8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f19bd8",
  null
  
)

export default component.exports